<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-12-29 18:40:06
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-01-12 17:51:07
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <DetailTopPart v-if="id" :orderId="id"></DetailTopPart>
      <OrderSettlement v-if="id" :orderId="id"></OrderSettlement>
    </div>
  </el-main>
</template>

<script>
import DetailTopPart from "./components/DetailTopPart";
import OrderSettlement from "./components/OrderSettlement";
export default {
  name: "FarmingOrderSettleDetail",
  components: {
    DetailTopPart,
    OrderSettlement,
  },
  data() {
    return {
      id: "",
    };
  },
  mounted() {
    this.id = this.$route.query.id;
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
</style>
